import React from 'react'

export default function FaceFeature({ scale, verticalOffset }) {
  const transformOrigin = '22.5 10.1'

  return (
    <g transform={`scale(${scale},${scale}) translate(0,${verticalOffset})`} transform-origin={transformOrigin}>
      <path
        d="M20.0801 4.99999C21.2601 9.40999 16.52 19.03 8.11003 18.61C1.10003 18.26 -1.17995 8.80998 2.57005 4.62998C5.25005 1.63998 10.3201 1.08998 14.2601 1.45998C17.5401 1.74998 19.4201 2.53999 20.0801 4.99999Z"
        stroke="#644534"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M24.9599 4.99999C23.7799 9.40999 28.5199 19.03 36.9299 18.61C43.9399 18.26 46.2199 8.80998 42.4699 4.62998C39.7899 1.63998 34.72 1.08998 30.78 1.45998C27.49 1.74998 25.6099 2.53999 24.9599 4.99999Z"
        stroke="#644534"
        strokeMiterlimit="10"
        fill="none"
      />
      <path
        d="M20.1401 5.55018C20.1401 5.55018 22.4701 4.30018 24.8001 5.55018"
        stroke="#644534"
        strokeMiterlimit="10"
      />
      <path
        d="M16.4399 1.80008C16.4399 1.80008 18.4399 1.58008 22.3599 1.58008C26.2799 1.58008 28.4899 1.80008 28.4899 1.80008"
        stroke="#644534"
        strokeMiterlimit="10"
      />
    </g>
  )
}
